import React, { Component } from 'react';
import { getStyle, styleMerge } from '../../utils/utils';
import CBMediaQuery from './CBMediaQuery';

// Reusable stats / summary header for list views.
// Desktop (large/medium): a horizontal flex row of label + big value blocks.
// Mobile (small): a 2-column grid so the stats wrap instead of overflowing off-screen.
// Props: items = [{ label, value, valueColor }]
class CBStatRow extends Component {
  render() {
    const { items, additionalStyles } = this.props;
    if (!items || items.length === 0) {
      return null;
    }
    return (
      <CBMediaQuery>
        {screenSize => (
          <div style={styleMerge(getStyle(screenSize, styles, 'container'), additionalStyles || {})}>
            {items.map((item, idx) => (
              <div key={idx} style={getStyle(screenSize, styles, 'item')}>
                <p className='font-titillium-web-regular' style={getStyle(screenSize, styles, 'label')}>
                  {item.label}
                </p>
                <p
                  className='font-titillium-web-bold'
                  style={styleMerge(
                    getStyle(screenSize, styles, 'value'),
                    item.valueColor ? { color: item.valueColor } : {},
                  )}
                >
                  {item.value}
                </p>
              </div>
            ))}
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    container: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 40,
      padding: '24px 16px 20px 16px',
    },
    item: {
      display: 'flex',
      flexDirection: 'column',
    },
    label: {
      color: 'rgba(255, 255, 255, 0.7)',
      fontSize: 12,
      margin: 0,
    },
    value: {
      color: '#FFFFFF',
      fontSize: 24,
      margin: 0,
    },
  },
  small: {
    container: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 16,
      padding: '16px',
    },
    value: {
      fontSize: 20,
    },
  },
};

export default CBStatRow;
